export class ListSecurityFindingsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "SecurityFindingsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortSecurityFindingsBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSecurityFindingsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
